import { createSlice } from '@reduxjs/toolkit';

const DEFAULT_VIEW_STATE = {
    filters: {},
    pagination: { page: 0, rowsPerPage: 10 },
    sort: { key: null, direction: null },
};

const initialState = {
    users: { ...DEFAULT_VIEW_STATE },
    tcm: { ...DEFAULT_VIEW_STATE },
    columns: {
        users: { hidden: [] },
        tcm: { hidden: [] },
    },
};

/**
 * Transient UI state for the V2 Users and TCM AddUser views (filters, pagination,
 * sort, column visibility). Excluded from redux-persist — resets on full reload,
 * survives in-app navigation. The `users` and `tcm` namespaces never cross-pollute.
 *
 * Registered under the `usersUi` reducer key to avoid colliding with the legacy
 * `users` reducer (redux/reducer/users.js). Rename back to `users` in the
 * legacy-cleanup PR once that reducer is removed.
 */
const usersUiSlice = createSlice({
    name: 'usersUi',
    initialState,
    reducers: {
        setFilters: (state, { payload: { view, filters } }) => {
            state[view].filters = filters;
        },
        setPagination: (state, { payload: { view, pagination } }) => {
            state[view].pagination = { ...state[view].pagination, ...pagination };
        },
        setSort: (state, { payload: { view, sort } }) => {
            state[view].sort = { ...state[view].sort, ...sort };
        },
        setHiddenColumns: (state, { payload: { view, hidden } }) => {
            state.columns[view].hidden = hidden;
        },
        resetView: (state, { payload: { view } }) => {
            state[view] = { ...DEFAULT_VIEW_STATE };
            state.columns[view] = { hidden: [] };
        },
    },
});

export const { setFilters, setPagination, setSort, setHiddenColumns, resetView } =
    usersUiSlice.actions;

export default usersUiSlice.reducer;
